import type { TaskPriority, TaskStatus, TaskVerificationStatus } from '@/types/task';

export const TASK_STATUS = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const satisfies Record<string, TaskStatus>;

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  PENDING: '待处理',
  IN_PROGRESS: '进行中',
  COMPLETED: '已完成',
  CANCELLED: '已取消',
};

export const TASK_VERIFICATION_LABELS: Record<TaskVerificationStatus, string> = {
  NOT_SUBMITTED: '未完成',
  PENDING_REVIEW: '待核验',
  VERIFIED_COMPLETED: '已完成',
  VERIFIED_INCOMPLETE: '核验未完成',
};

export const TASK_PRIORITY = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
} as const satisfies Record<string, TaskPriority>;

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  LOW: '低',
  MEDIUM: '中',
  HIGH: '高',
  URGENT: '紧急',
};

export function taskStatusTagClass(status: TaskStatus): string {
  switch (status) {
    case TASK_STATUS.IN_PROGRESS:
      return 'mobile-tag mobile-tag--primary';
    case TASK_STATUS.COMPLETED:
      return 'mobile-tag mobile-tag--success';
    case TASK_STATUS.CANCELLED:
      return 'mobile-tag';
    default:
      return 'mobile-tag mobile-tag--warning';
  }
}

export function taskPriorityTagClass(priority: TaskPriority): string {
  switch (priority) {
    case TASK_PRIORITY.URGENT:
    case TASK_PRIORITY.HIGH:
      return 'mobile-tag mobile-tag--danger';
    case TASK_PRIORITY.MEDIUM:
      return 'mobile-tag mobile-tag--warning';
    default:
      return 'mobile-tag';
  }
}
